import { FIELD_TYPES } from "constants/template-field-type";
import gridImageFieldsConfig from "segments/desktop/core-components/grid-image/fields-config";

import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ParagraphBodyConfig from "segments/desktop/core-components/paragraph/fields-config";
import SecondaryButtonFieldsConfig from "segments/desktop/core-components/button/secondary-button/fields-config";

const { link, ...restGridFields } = gridImageFieldsConfig;

export default {
  ...restGridFields,
  fullParagraph: {
    type: FIELD_TYPES.NESTED,
    label: "Full Paragraph",
    fields: {
      ...TitleConfig,
      ...ParagraphBodyConfig,
      buttonConfig: {
        type: FIELD_TYPES.NESTED,
        label: "Secondary Button",
        fields: SecondaryButtonFieldsConfig
      }
    }
  }
};
